export default {
  path: '/search',
  meta: {
    title: '大厅',
    keepAlive: true,
  },
  component: r => require.ensure([], () => r(require(`./index.vue`)), `/search`),
}



// WEBPACK FOOTER //
// ./src/views/Search/router.js